import { render, staticRenderFns } from "./ImportLoadDataUpload.vue?vue&type=template&id=9220b860&scoped=true&"
import script from "./ImportLoadDataUpload.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ImportLoadDataUpload.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ImportLoadDataUpload.vue?vue&type=style&index=0&id=9220b860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9220b860",
  null
  
)

export default component.exports